import React from 'react'
import some from 'lodash/some'
import CmsImageCarousel from 'cms/CmsImageCarousel'

const checkValidImages = (images) => (
  images && images.length && some(images, (image) => image.source)
)

const ImageCarousel = ({
  defaultContent: {
    images = [],
  },
  deviceContent = {},
  screen,
  style,
  goto,
  assets: {
    defaultImage,
  },
  renderElement,
  deviceSettings,
}) => {
  const extractedContent = deviceContent[screen] || {}
  const representImages = checkValidImages(extractedContent.images) ?
    extractedContent.images
    :
    images
  return (
    renderElement(
      CmsImageCarousel,
      {
        settings: deviceSettings[screen],
        images: representImages,
        style,
        goto,
        defaultImage,
      },
    )
  )
}

ImageCarousel.propTypes = {}
ImageCarousel.defaultProps = {}

export default ImageCarousel



// WEBPACK FOOTER //
// ./src/components/Canvas/renderer/elements/imageCarousel/ImageCarousel.js